export default "__VITE_ASSET__603b06aa__"